import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DuplicateDetectionModal = ({ duplicates, onClose, onMerge, onIgnore }) => {
  if (!duplicates || duplicates?.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-warning/10 flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-warning" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-foreground">Mögliche Duplikate erkannt</h2>
              <p className="text-sm text-muted-foreground">
                {duplicates?.length} ähnliche {duplicates?.length === 1 ? 'Eintrag' : 'Einträge'} gefunden
              </p>
            </div>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
          <div className="space-y-4">
            {duplicates?.map((duplicate) => (
              <div key={duplicate?.id} className="bg-muted/30 rounded-lg p-4 border border-border">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon name="User" size={24} className="text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground">
                        {duplicate?.firstName} {duplicate?.lastName}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        Kunden-ID: {duplicate?.clientId}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-warning/10">
                    <Icon name="Percent" size={16} className="text-warning" />
                    <span className="text-sm font-medium text-warning">
                      {duplicate?.matchScore}% Übereinstimmung
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-sm">
                      <Icon name="Calendar" size={16} className="text-muted-foreground" />
                      <span className="text-muted-foreground">Geburtsdatum:</span>
                      <span className="font-medium text-foreground">{duplicate?.dateOfBirth}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm">
                      <Icon name="Phone" size={16} className="text-muted-foreground" />
                      <span className="text-muted-foreground">Telefon:</span>
                      <span className="font-medium text-foreground">{duplicate?.phone}</span>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-sm">
                      <Icon name="Mail" size={16} className="text-muted-foreground" />
                      <span className="text-muted-foreground">E-Mail:</span>
                      <span className="font-medium text-foreground">{duplicate?.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm">
                      <Icon name="MapPin" size={16} className="text-muted-foreground" />
                      <span className="text-muted-foreground">Adresse:</span>
                      <span className="font-medium text-foreground">{duplicate?.address}</span>
                    </div>
                  </div>
                </div>

                <div className="bg-background rounded p-3 mb-3">
                  <h4 className="text-sm font-medium text-foreground mb-2">Übereinstimmende Felder:</h4>
                  <div className="flex flex-wrap gap-2">
                    {duplicate?.matchingFields?.map((field, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-accent/10 text-accent text-xs rounded-full"
                      >
                        {field}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex gap-2">
                  <Button
                    variant="default"
                    size="sm"
                    iconName="GitMerge"
                    iconPosition="left"
                    onClick={() => onMerge(duplicate?.id)}
                  >
                    Profile zusammenführen
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onIgnore(duplicate?.id)}
                  >
                    Ignorieren
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-between p-6 border-t border-border bg-muted/30">
          <p className="text-sm text-muted-foreground">
            Überprüfen Sie die Duplikate sorgfältig, bevor Sie fortfahren
          </p>
          <Button variant="outline" onClick={onClose}>
            Alle ignorieren und fortfahren
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateDetectionModal;